module.exports = __webpack_public_path__ + "static/img/02.3622d7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zongce/02.jpg
// module id = hMGK
// module chunks = 1